import React from 'react';

export default class Sidebar extends React.Component {
    render() {
        return (
            <p>This is the sidebar</p>
        )
    }
}